export default {
    copyRow(table, rowData, excludeFields, that) {
        excludeFields.forEach((excludeField) => {
            rowData[excludeField.field] = excludeField.default;
        });
        table.addRow(rowData, false).then((r) => {
            that.$emit("copy-event");
        });

    }
};